import React from 'react'

const MyLoadsContentSkeleton = () => {
    return (
        <div className="w-full flex flex-col gap-4 lg:h-[calc(100vh-10rem)] overflow-y-auto py-6 px-4">
            {/* header placeholders */}
            {/* <div className="flex items-center justify-between mb-4">
        <div className="h-6 w-40 bg-gray-300 rounded animate-pulse" />
        <div className="h-6 w-24 bg-gray-300 rounded animate-pulse" />
      </div> */}

            {/* list of load placeholders */}
            <div className="flex flex-col gap-6">
                {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="flex flex-col gap-3 p-4 rounded border border-gray-200 bg-white">

                        <div className="h-4 w-28 bg-gray-300 rounded animate-pulse" />
                        <div className="h-4 w-32 bg-gray-300 rounded animate-pulse" />
                        <div className='flex gap-4'>
                            <div className="h-4 w-28 bg-gray-300 rounded animate-pulse" />
                            <div className="h-4 w-28 bg-gray-300 rounded animate-pulse" />
                        </div>

                        <div className="h-4 w-20 bg-gray-300 rounded animate-pulse" />
                        <div className="h-4 w-32 bg-gray-300 rounded animate-pulse" />

                        <div className="h-12 w-2/5 bg-gray-300 rounded animate-pulse" />

                        <div className="flex gap-3 mt-2">
                            <div className="h-10 w-40 bg-gray-300 border border-gray-500 rounded animate-pulse" />
                            <div className="h-10 w-28 bg-gray-300 border border-gray-500 rounded animate-pulse" />
                            <div className="h-10 w-20 bg-gray-300 border border-gray-500 rounded animate-pulse" />
                        </div>
                    </div>
                ))}
            </div>

            {/* footer/load-more placeholder */}
            <div className="w-full flex justify-center mt-6">
                <div className="h-10 w-32 bg-gray-300 rounded animate-pulse" />
            </div>
        </div>
    )
}

export default MyLoadsContentSkeleton
